import { render, staticRenderFns } from "./NoLoginLayout.vue?vue&type=template&id=4478afd0"
import script from "./NoLoginLayout.vue?vue&type=script&lang=js"
export * from "./NoLoginLayout.vue?vue&type=script&lang=js"
import style0 from "./NoLoginLayout.vue?vue&type=style&index=0&id=4478afd0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports